import { render, staticRenderFns } from "./App.vue?vue&type=template&id=683f2cf4&scoped=true"
import script from "./app.ts?vue&type=script&lang=ts&external"
export * from "./app.ts?vue&type=script&lang=ts&external"
import style0 from "./app.scss?vue&type=style&index=0&id=683f2cf4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683f2cf4",
  null
  
)

export default component.exports